import { RESET_APP } from '../../constants/action_types';

export const resetApp = () => ({
  type: RESET_APP,
});
